// tooth or teeth
// with new flow
export const RECORD_ADD_OR_UPDATE_TYPE = "RECORD_ADD_OR_UPDATE_TYPE";

export const TOOTH_TOGGLE_SELECTION = "TOOTH_TOGGLE_SELECTION";
export const QUADRANT_TOGGLE_SELECTION = "QUADRANT_TOGGLE_SELECTION";
export const CONDITION_AND_SUB_CONDITION_SELECTION =
  "CONDITION_AND_SUB_CONDITION_SELECTION";
export const CONDITION_AND_SUB_CONDITION_SELECTION_FOR_QUADRANT =
  "CONDITION_AND_SUB_CONDITION_SELECTION_FOR_QUADRANT";
export const QUADRANT_SELECTION_COMPLETED = "QUADRANT_SELECTION_COMPLETED";

// end new flow
export const TOOTH_SELECTION = "TOOTH_SELECTION";
export const MARK_ALL_SELECTION = "MARK_ALL_SELECTION";
export const RESET_ALL_SELECTION = "RESET_ALL_SELECTION";

export const CONDITION_SELECTION = "CONDITION_SELECTION";
export const SUB_CONDITION_SELECTION = "SUB_CONDITION_SELECTION";
export const CLASS_SELECTION = "CLASS_SELECTION";
export const SELECTION_COMPLETED = "SELECTION_COMPLETED";
export const CLEAR_DENTAL_RECORD_DATA = "CLEAR_DENTAL_RECORD_DATA";
export const SET_DENTAL_RECORD_TO_UPDATE = "SET_DENTAL_RECORD_TO_UPDATE";
export const ADD_TOOTH_OBSERVATION = "ADD_TOOTH_OBSERVATION";
export const DELETE_TOOTH_OBSERVATION = "DELETE_TOOTH_OBSERVATION";
export const CLEAR_TEMPOBJECT_AND_TEM_QUADRANT =
  "CLEAR_TEMPOBJECT_AND_TEM_QUADRANT";
export const UPDATE_TOOTH_OBSERVATION = "UPDATE_TOOTH_OBSERVATION";

// quadrant
export const QUADRANT_SELECTION = "QUADRANT_SELECTION";
export const QUADRANT_CONDITION_SELECTION = "QUADRANT_CONDITION_SELECTION";
export const ADD_QUADRANT_OBSERVATION = "ADD_QUADRANT_OBSERVATION";
export const DELETE_QUADRANT_OBSERVATION = "DELETE_QUADRANT_OBSERVATION";
export const UPDATE_QUADRANT_OBSERVATION = "UPDATE_QUADRANT_OBSERVATION";
export const EDIT_TOOTH_OR_QUADRANT_OBSERVATION_FROM_LIST =
  "EDIT_TOOTH_OR_QUADRANT_OBSERVATION_FROM_LIST";

export const RESET_CURRENT_INDENTIFICATION_TEETH =
  "RESET_CURRENT_INDENTIFICATION_TEETH";
export const RESET_CURRENT_INDENTIFICATION_QUADRANT =
  "RESET_CURRENT_INDENTIFICATION_QUADRANT";

export const _onToogleTeethSelection = (tooth_id) => {
  return (dispatch) => {
    dispatch({
      type: TOOTH_TOGGLE_SELECTION,
      payload: tooth_id,
    });
  };
};
export const _onQuadrantSelectionForMarking = (quadrant_identifer) => {
  return (dispatch) => {
    dispatch({
      type: QUADRANT_TOGGLE_SELECTION,
      payload: quadrant_identifer,
    });
  };
};

// SELECT ALL AND RESET ALL

export const _markAllTeethSelection = () => {
  return (dispatch) => {
    dispatch({
      type: MARK_ALL_SELECTION,
    });
  };
};
export const _resetAllTeethSelection = () => {
  return (dispatch) => {
    dispatch({
      type: RESET_ALL_SELECTION,
    });
  };
};

export const _onConditionAndSubConditionSelectionForTeeth = ({
  conditions = [], // Default to empty string
  subConditions = [], // Default to empty array for multiple conditions
}) => {
  return (dispatch) => {
    dispatch({
      type: CONDITION_AND_SUB_CONDITION_SELECTION,
      payload: {
        conditions,
        subConditions, // Directly pass the updated subConditions array
      },
    });
  };
};

export const _onConditionAndSubConditionSelectionForQuadrant = ({
  conditions, // Array of condition objects
  subConditions, // Array of sub-condition IDs
}) => {
  return (dispatch) => {
    dispatch({
      type: CONDITION_AND_SUB_CONDITION_SELECTION_FOR_QUADRANT,
      payload: {
        conditions,
        subConditions,
      },
    });
  };
};

export const _onToothSelectionForMarking = (tooth_id) => {
  return (dispatch) => {
    dispatch({
      type: TOOTH_SELECTION,
      payload: tooth_id,
    });
  };
};

export const _onConditionSelectionForSelectedTooth = (condition) => {
  return (dispatch) => {
    dispatch({
      type: CONDITION_SELECTION,
      payload: condition,
    });
  };
};
export const _onSubConditionSelectionForSelectedTooth = (sub_condition_id) => {
  return (dispatch) => {
    dispatch({
      type: SUB_CONDITION_SELECTION,
      payload: sub_condition_id,
    });
  };
};
export const _onClassSelectionForSelectedTooth = (class_id) => {
  return (dispatch) => {
    dispatch({
      type: CLASS_SELECTION,
      payload: class_id,
    });
  };
};
export const _onSelectionCompletedForSelectedTooth = () => {
  return (dispatch) => {
    dispatch({
      type: SELECTION_COMPLETED,
    });
  };
};
export const _onSelectionCompletedForSelectedQuadrant = () => {
  return (dispatch) => {
    dispatch({
      type: QUADRANT_SELECTION_COMPLETED,
    });
  };
};
export const _onClearDentalRecordData = () => {
  return (dispatch) => {
    dispatch({
      type: CLEAR_DENTAL_RECORD_DATA,
    });
  };
};

export const _onSetDentalRecordDataForUpdate = (data, quadrantData) => {
  return (dispatch) => {
    dispatch({
      type: SET_DENTAL_RECORD_TO_UPDATE,
      payload: { data, quadrantData },
    });
  };
};

export const _onQuadrantSelection = (quadrant) => {
  return (dispatch) => {
    dispatch({
      type: QUADRANT_SELECTION,
      payload: quadrant,
    });
  };
};
export const _onQuadrantConditionSelection = (condition_id) => {
  return (dispatch) => {
    dispatch({
      type: QUADRANT_CONDITION_SELECTION,
      payload: condition_id,
    });
  };
};
export const _onDeleteToothObservation = (id) => {
  return (dispatch) => {
    dispatch({
      type: DELETE_TOOTH_OBSERVATION,
      payload: id,
    });
  };
};

// OBSERVATIONS

export const _onAddToothObservation = (observation) => {
  return (dispatch) => {
    dispatch({
      type: ADD_TOOTH_OBSERVATION,
      payload: { observation: observation },
    });
  };
};
export const _onAddQuadrantObservation = (observation) => {
  return (dispatch) => {
    dispatch({
      type: ADD_QUADRANT_OBSERVATION,
      payload: { observation: observation },
    });
  };
};

export const _onDeleteQuadrantObservation = (identifier) => {
  return (dispatch) => {
    dispatch({
      type: DELETE_QUADRANT_OBSERVATION,
      payload: identifier,
    });
  };
};
export const _onClearTempTeethObjectAndTemQuadrant = () => {
  return (dispatch) => {
    dispatch({
      type: CLEAR_TEMPOBJECT_AND_TEM_QUADRANT,
    });
  };
};
export const _onRecordUpdate = (toggle) => {
  return (dispatch) => {
    dispatch({
      type: RECORD_ADD_OR_UPDATE_TYPE,
      payload: toggle,
    });
  };
};

export const _updateToothObservation = (tooth_id, observation) => {
  return (dispatch) => {
    dispatch({
      type: UPDATE_TOOTH_OBSERVATION,
      payload: { t_id: tooth_id, t_observation: observation },
    });
  };
};
export const _updateQuadrantObservation = (quadrant_identifer, observation) => {
  return (dispatch) => {
    dispatch({
      type: UPDATE_QUADRANT_OBSERVATION,
      payload: { q_id: quadrant_identifer, q_observation: observation },
    });
  };
};

export const _selectToothOrQuadrantForObservationUpdateFromList = (
  updateType,
  idOrIdentifier
) => {
  return (dispatch) => {
    dispatch({
      type: EDIT_TOOTH_OR_QUADRANT_OBSERVATION_FROM_LIST,
      payload: {
        updateType: updateType, // "tooth" or "quadrant"
        identifier: idOrIdentifier, // could be tooth_id or quadrant identifier
      },
    });
  };
};
export const _onRsetCurrentCompletedToothForIndentification = () => {
  return (dispatch) => {
    dispatch({
      type: RESET_CURRENT_INDENTIFICATION_TEETH,
    });
  };
};

export const _onRsetCurrentCompletedQuadrantForIndentification = () => {
  return (dispatch) => {
    dispatch({
      type: RESET_CURRENT_INDENTIFICATION_QUADRANT,
    });
  };
};
